import { SharedValue, useSharedValue } from 'react-native-reanimated';

export interface IPaneSlot {
  scale: SharedValue<number>;
  translateX: SharedValue<number>;
  translateY: SharedValue<number>;
  baseScale: SharedValue<number>;
  lastScale: SharedValue<number>;
  lastTranslateX: SharedValue<number>;
  lastTranslateY: SharedValue<number>;
}

export interface IPaneSlots {
  slots: [IPaneSlot, IPaneSlot, IPaneSlot];
  // Worklet-readable index of the slot currently considered "active" (always 1
  // in steady state since the track is always centered on slot 1, but lifted
  // out as a SV so callers don't have to hard-code it).
  activeSlot: SharedValue<number>;
}

const useSlot = (): IPaneSlot => ({
  scale: useSharedValue(1),
  translateX: useSharedValue(0),
  translateY: useSharedValue(0),
  baseScale: useSharedValue(1),
  lastScale: useSharedValue(1),
  lastTranslateX: useSharedValue(0),
  lastTranslateY: useSharedValue(0),
});

// Fixed pool of 3 per-pane SV bags. The mapping from slot index (0=left,
// 1=center/active, 2=right) to photo index is owned by the carousel, but the
// SV bags themselves are stable across re-renders so worklets can hold direct
// references to each slot and the active pane's transforms reset cleanly when
// activeIndex changes.
export const usePaneSlots = (): IPaneSlots => ({
  slots: [useSlot(), useSlot(), useSlot()],
  activeSlot: useSharedValue<number>(1),
});
